module.exports = __webpack_public_path__ + "img/mx.mxa17b7ad.svg";